/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 既往歴
 */
export type RequestSummaryMedicalHistoryEnum =
  (typeof RequestSummaryMedicalHistoryEnum)[keyof typeof RequestSummaryMedicalHistoryEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestSummaryMedicalHistoryEnum = {
  HYPER_TENSION: 'HYPER_TENSION',
  HYPER_LIPIDEMIA: 'HYPER_LIPIDEMIA',
  COPD: 'COPD',
  DIABETES: 'DIABETES',
  MYOCARDIAL_INFARCTION: 'MYOCARDIAL_INFARCTION',
  CANCER: 'CANCER',
  CEREBRAL_INFARCTION: 'CEREBRAL_INFARCTION',
  DEMENTIA: 'DEMENTIA',
  EPILEPSY: 'EPILEPSY',
  ANGINA: 'ANGINA',
  KIDNEY_FAILURE: 'KIDNEY_FAILURE',
  HEART_FAILURE: 'HEART_FAILURE',
  DIALYSIS: 'DIALYSIS',
  MENTAL_ILLNESS: 'MENTAL_ILLNESS',
  ASTHMA: 'ASTHMA',
  ARRHYTHMIA: 'ARRHYTHMIA',
  OTHER_HEART_DISEASES: 'OTHER_HEART_DISEASES',
  CEREBROVASCULAR: 'CEREBROVASCULAR',
  RESPIRATORY_DISEASES: 'RESPIRATORY_DISEASES',
  LIVER_DISEASES: 'LIVER_DISEASES',
  KIDNEY_DISEASES: 'KIDNEY_DISEASES',
  DIGESTIVE_DISEASES: 'DIGESTIVE_DISEASES',
  CEREBRAL_HEMORRHAGE: 'CEREBRAL_HEMORRHAGE',
  CIRCULATORY_SYSTEM: 'CIRCULATORY_SYSTEM',
  NERVOUS_SYSTEM: 'NERVOUS_SYSTEM',
  ENDOCRINE_SYSTEM: 'ENDOCRINE_SYSTEM',
  HEMATOLOGY: 'HEMATOLOGY',
  OBSTETRICS_AND_GYNECOLOGY: 'OBSTETRICS_AND_GYNECOLOGY',
  INFECTIOUS_DISEASES: 'INFECTIOUS_DISEASES',
  RENAL_UROLOGY: 'RENAL_UROLOGY',
  ALLERGY: 'ALLERGY',
  OTHER: 'OTHER',
} as const;
